import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlimScrollModule } from 'ng2-slimscroll';
import { MemberRoutingModule } from './member-routing.module';
import { AddMemberComponent } from './add-member/add-member.component';
import { MemberListComponent } from './member-list/member-list.component';
import { SharedModule } from './../shared/shared.module';
import { MemberDetailComponent } from './member-detail/member-detail.component';
import { MemberDisableComponent } from './member-disable/member-disable.component';
import { DisablePopupComponent } from './disable-popup/disable-popup.component';
import { EnablePopupComponent } from './enable-popup/enable-popup.component';
import { MemberInactiveComponent } from './member-inactive/member-inactive.component';
import { OnBoardingModule } from './../on-boarding/on-boarding.module';
import { ShowLogComponent } from './show-log/show-log.component';
import { TabsModule } from 'ng2-bootstrap/components/tabs';
import { DownloadTemplateComponent } from './download-template/download-template.component';
// import { LinkActivitiesPopupComponent } from './add-member/link-activities/link-activities.component';
import { LinkActivitiesUnitPopupComponent } from './add-member/link-activity-unit/link-activities-unit.component';
import { StaffListComponent } from './staff-list/staff-list.component';
@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    MemberRoutingModule,
    SlimScrollModule,
    OnBoardingModule,
    TabsModule
  ],
  exports: [
    DisablePopupComponent
  ],
  declarations: [AddMemberComponent, MemberListComponent, StaffListComponent, MemberDetailComponent, MemberDisableComponent, DisablePopupComponent, EnablePopupComponent, MemberInactiveComponent, ShowLogComponent, DownloadTemplateComponent,LinkActivitiesUnitPopupComponent]
})
export class MemberModule { }



// WEBPACK FOOTER //
// ./src/app/member/member.module.ts